import { z } from 'zod';
export const PDGMSchema = z.object({
    SectionA: z
        .object({
        m0030: z.string().date(),
        m0032: z.string().date().nullish(),
        m0100: z.string().trim().min(1, 'required'),
        m1000: z.array(z.string().trim().min(1, 'required')).nonempty(),
    })
        .superRefine((values, ctx) => {
        if (values.m0100 === '03' && !values.m0032) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'required',
            });
        }
    }),
    SectionG: z.object({
        m1800: z.string().trim().min(1, 'required'),
        m1810: z.string().trim().min(1, 'required'),
        m1820: z.string().trim().min(1, 'required'),
        m1830: z.string().trim().min(1, 'required'),
        m1840: z.string().trim().min(1, 'required'),
        m1850: z.string().trim().min(1, 'required'),
        m1860: z.string().trim().min(1, 'required'),
    }),
    SectionI: z.object({
        m1021: z.object({
            code: z.string().trim().min(1, 'required'),
        }),
        m1023: z.array(z.object({
            code: z.string().trim().min(1, 'required'),
        })),
    }),
    SectionJ: z.object({
        m1033: z.array(z.string().trim().min(1, 'required')).nonempty(),
    }),
});
